/**
 * ModuleActionButtons - Action buttons for module management
 *
 * Auto-Fill, Clear All, Clear Selection, and Delete Selected buttons.
 */

import React from 'react';

interface ModuleActionButtonsProps {
  onAutoFill: () => void;
  onClearAll: () => void;
  onClearSelection: () => void;
  onDeleteSelected: () => void;
  hasSelection: boolean;
}

export function ModuleActionButtons({
  onAutoFill,
  onClearAll,
  onClearSelection,
  onDeleteSelected,
  hasSelection,
}: ModuleActionButtonsProps) {
  return (
    <div className="space-y-2 pt-2">
      <div className="flex gap-2">
        <button
          onClick={onAutoFill}
          className="flex-1 py-2 px-4 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors text-xs font-semibold"
        >
          Auto-Fill
        </button>
        <button
          onClick={onClearAll}
          className="flex-1 py-2 px-4 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors text-xs font-semibold"
        >
          Clear All
        </button>
      </div>

      <div className="flex gap-2 mt-2">
        <button
          onClick={onClearSelection}
          className="flex-1 py-2 px-4 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-xs font-semibold"
          disabled={!hasSelection}
        >
          Clear Selection
        </button>
        <button
          onClick={onDeleteSelected}
          className="flex-1 py-2 px-4 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-xs font-semibold disabled:bg-gray-300 disabled:cursor-not-allowed"
          disabled={!hasSelection}
        >
          Delete Selected
        </button>
      </div>
    </div>
  );
}

export default ModuleActionButtons;
